<template>
  <div class="inner-footer">
    <div class="inner">
      <div class="inner-contact">
        <div class="conta-title">
          <span>{{inner.INNER_ONE}}</span>
        </div>
        <div class="contact-cont">
          <ul>
            <li>
              <!-- <Icon type="md-pin" /> -->
              <Icon style="font-size: 30px; padding-top: 2px" type="md-pin" />
              {{inner.INNER_PIN}}
            </li>
            <li>
              <!-- <Icon type="md-call" /> -->
              <Icon style="font-size: 30px; padding-top: 2px" type="md-call" />
              {{inner.INNER_TEL}}
            </li>
            <li>
              <!-- <Icon type="md-mail" /> -->
              <!-- <Icon style="font-size: 30px; padding-top: 2px" type="md-mail" /> -->
              <!-- {{inner.INNER_MAIL}} -->
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="inner-contact">
        <div class="conta-title">
          <span>{{inner.INNER_TWO}}</span>
        </div>
        <div class="contact-focus">
          <ul>
            <li>
              <p style="margin-top:5px;">{{inner.INNER_WEIBO}}</p>
              <ul>
                <li class="xinlan">
                  <a href="http://weibo.com/25488764" target="_blank" title="关注新浪微博">{{inner.INNER_WEIBO}}</a>
                </li>
                <li class="tenxun">
                  <a href="http://weibo.com/25488764" target="_blank" title="关注腾讯微博">{{inner.INNER_TWEIBO}}</a>
                </li>
                <li class="qq">
                  <a href="http://weibo.com/25488764" target="_blank" title="联系QQ客服">{{inner.INNER_QQ}}</a>
                </li>
              </ul>
            </li>
            <li>
              <p style="margin:5px 0 10px 0;">{{inner.INNER_WEIX}}</p>
              <img style="width:90px;height:90px;" :src="inner.INNER_QR">
            </li>
          </ul>
        </div>
      </div> -->
      <div class="inner-contact">
        <div class="conta-title">
          <span>{{inner.INNER_THREE}}</span>
        </div>
        <div class="contact-links">
          <!-- <div class="icon"><img :src="inner.INNER_ICON1"></div> -->
          <!-- <div class="icon"><img :src="inner.INNER_ICON2"></div> -->
          <div style="padding-top:40px">
            <a class="link" href="">{{inner.INNER_LINK1}}</a>
            <a class="link" href="">{{inner.INNER_LINK2}}</a>
            <a class="link" href="">{{inner.INNER_LINK3}}</a><br>
            <a class="link" href="">{{inner.INNER_LINK4}}</a>
            <a class="link" href="">{{inner.INNER_LINK5}}</a><br>
            <a class="link" href="">{{inner.INNER_LINK6}}</a>
            <a class="link" href="">{{inner.INNER_LINK7}}</a><br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      inner: []
    }
  },
  mounted () {
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.inner = response.data.INNER
        // console.log(this.inner)
      })
  }
}
</script>

<style lang="less" scoped>
@media only screen and (min-width: 900px) {
  .inner-footer {
    display: flex;
    width: 100%;
  }
  .inner-contact {
      float: left;
      width: 33%;
  }
  .inner {
    margin: 0 auto;
    max-width: 1200px;
    width: 96%;
  }
}
@media only screen and (max-width: 900px) {
  .inner-contact {
    display: block;
  }
  .inner {
    padding: 0 10%;
    width: 100%;
  }
  // .nav {
  //   width: 100%;
  // }
}
.inner-footer {
  // height: 330px;
  padding: 40px 0 50px;
  background-color: #fff;
  border-top: 1px solid #dadada;
  // border-bottom: 1px solid #dadada;
  .inner {
    // padding: 0 10%;
    // width: 100%;
    .inner-contact {
      // float: left;
      // width: 33%;
      .conta-title {
        margin-right: 25px;
        height: 40px;
        border-bottom: 1px solid #5a5a5a;
        color: #5a5a5a;
        font-size: 16px;
        line-height: 40px;
        span {
          position: relative;
          top: -1px;
          display: inline-block;
          border-bottom: 3px solid #5a5a5a;
        }
      }
      .contact-cont {
        margin-right: 25px;
        ul li {
          font-size: 14px;
          position: relative;
          margin-top: 25px;
          padding-top: 5px;
          // padding-left: 48px;
          min-height: 35px;
          color: #474747;
          list-style: none;
          }
        }
      }
      .contact-focus {
        margin-right: 25px;
        padding: 20px 0;
        color: #474747;
        font-size: 14px;
        ul li {
          list-style: none;
          ul li.xinlan {
            display: inline-block;
            margin: 8px;
            list-style: none;
            a {
              display: block;
              overflow: hidden;
              width: 44px;
              height: 44px;
              background: url(http://www.hncjdb.com/templates/metx5/images/pnt.png) no-repeat left top;
              color: #474747;
              font-size: 0;
            }
            a:hover {
              background: url(http://www.hncjdb.com/templates/metx5/images/pnthover.png) no-repeat;
            }
          }
            ul li.tenxun {
            display: inline-block;
            margin: 8px;
            list-style: none;
            a {
              display: block;
              overflow: hidden;
              width: 44px;
              height: 44px;
              background: url(http://www.hncjdb.com/templates/metx5/images/pnt.png) -83px top!important;
              color: #474747;
              font-size: 0;
            }
            a:hover {
              background: url(http://www.hncjdb.com/templates/metx5/images/pnthover.png) -83px top!important;
            }
          }
            ul li.qq {
            display: inline-block;
            margin: 8px;
            list-style: none;
            a {
              display: block;
              overflow: hidden;
              width: 44px;
              height: 44px;
              background: url(http://www.hncjdb.com/templates/metx5/images/pnt.png) -165px top!important;
              color: #474747;
              font-size: 0;
            }
            a:hover {
              background: url(http://www.hncjdb.com/templates/metx5/images/pnthover.png) -165px top!important;
            }
          }
        }
      }
      .contact-links {
        display: inline-block;
        .icon {
          margin: 20px 10px 0 0;
          display: inline-flex;
          img {
          height: 45px;
          width: 45px;
          }
        }
        .link {
          display: inline-block;
          margin: 0 12px 10px 0;
          color: #474747;
          white-space: nowrap;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/inner.vue